import { gql } from "gql";

export const FIND_COMPANY_DOCUMENTS = gql(/* GraphQL */ `
  query FindCompanyDocuments(
    $pageableRequest: PageRequest!
    $filter: CompanyDocumentFilter
  ) {
    findCompanyDocuments(pageableRequest: $pageableRequest, filter: $filter) {
      content {
        id
        needReadConfirmation
        mySignRegistration {
          id
        }

        ...CompanyDocumentName
        ...CompanyDocumentDescription
        ...CompanyDocumentReadConfirmationType

        file {
          link
          downloadLink
          ...FileForDocumentButton
        }
        folder {
          ... on CompanyDocumentFolderDto {
            id
            ...CompanyDocumentFolderName
          }
          ... on Hidden {
            ...Hidden
          }
        }
      }
      total
    }
  }
`);
